import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/auth/AuthContext";

export default function AuthCallback() {
  const { finishGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    finishGoogle(sessionId)
      .then((u) => {
        // strip hash before navigating
        window.history.replaceState({}, "", window.location.pathname);
        // Service providers land on their dedicated app surface.
        const dest = u?.system_role === "service_provider" ? "/sp/dashboard" : "/dashboard";
        navigate(dest, { replace: true });
      })
      .catch((e) => {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      });
  }, [finishGoogle, navigate]);

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      data-testid="auth-callback"
    >
      <div className="flex items-center gap-3" style={{ color: "var(--slate)" }}>
        <span className="ai-dot" />
        <span className="ai-dot" />
        <span className="ai-dot" />
        <span className="text-sm ml-2">Signing you in…</span>
      </div>
    </div>
  );
}
